import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a53d947a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a53d947a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53d947a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a53d947a')) {
      api.createRecord('a53d947a', component.options)
    } else {
      api.reload('a53d947a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a53d947a&scoped=true", function () {
      api.rerender('a53d947a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/index.vue"
export default component.exports